import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-770b3674")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "_header head",
  ref: "header"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "_img logo" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "brand" }, [
  /*#__PURE__*/_createElementVNode("span", null, "go"),
  /*#__PURE__*/_createElementVNode("span", null, "chase."),
  /*#__PURE__*/_createElementVNode("span", null, "me")
], -1)
const _hoisted_5 = { class: "but" }
const _hoisted_6 = { class: "but small" }
const _hoisted_7 = { class: "billboard" }
const _hoisted_8 = { class: "meta" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h1", { class: "_hero" }, [
  /*#__PURE__*/_createTextVNode("Online"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("escape"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("rooms")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, " Online games where you use anything and everything to beat the clock and escape! ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, "Learn more", -1)
const _hoisted_12 = { class: "room" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "row guide" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("h1", null, "How do I play?")
  ])
], -1)
const _hoisted_14 = {
  class: "row img_right",
  id: "one"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "1. Host")
], -1)
const _hoisted_16 = { class: "hider" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", null, "Login with Facebook", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", null, "Find your next game", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "Purchase a game for the cost of a coffee", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, "Lobby created - time to invite", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "meta" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" One purchase, infinite replays ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Varying prices & game bundles ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Free games in the mix ")
const _hoisted_29 = { class: "img" }
const _hoisted_30 = {
  class: "row img_left",
  id: "two"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "2. Invite")
], -1)
const _hoisted_32 = { class: "hider" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h3", null, "Gather your friends", -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h3", null, "No login required to join", -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", null, "Joining players don't pay", -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h3", null, "You're ready to play!", -1)
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = { class: "meta" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Share your lobby code or url ")
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" No lobby size limit ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Or, tackle the game solo to truly test your skill ")
const _hoisted_45 = { class: "img" }
const _hoisted_46 = {
  class: "row img_right",
  id: "three"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "3. Play!")
], -1)
const _hoisted_48 = { class: "hider" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h3", null, "Start your game", -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h3", null, "Use anything to answer those questions", -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h3", null, "Decipher clues and analyse everything", -1)
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("h3", null, "Piece it all together and escape!", -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = { class: "meta" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" Best your times and challenge others ")
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Games of different sizes and difficulties ")
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" Rate your experiences to provide feedback ")
const _hoisted_61 = { class: "img" }
const _hoisted_62 = { class: "row large img_right" }
const _hoisted_63 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-770b3674><h1 data-v-770b3674>Why wait?</h1></div><div class=\"text wrap\" data-v-770b3674><h3 data-v-770b3674>Find a game and play today!</h3><p style=\"margin-top:1.5em;\" data-v-770b3674>We are always adding new games to our collection. Want to delve further and become a collaborator or partners? Get in contact with us today.</p><div class=\"_b\" data-v-770b3674></div></div><div class=\"img\" data-v-770b3674><div id=\"startedImg\" class=\"title _img screens\" data-v-770b3674></div></div>", 3)
const _hoisted_66 = { class: "button" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!
  const _component_Room = _resolveComponent("Room")!
  const _component_LandingHost = _resolveComponent("LandingHost")!
  const _component_LandingInvite = _resolveComponent("LandingInvite")!
  const _component_LandingPlay = _resolveComponent("LandingPlay")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_IconButton, {
          text: "Get started",
          hex: "#FFFFFF",
          colored: true,
          icon: "forward",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/app'})))
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_IconButton, {
          class: "headerPlayIcon",
          text: "Play",
          icon: "forward",
          autoplay: true,
          loop: true,
          hex: "#FFFFFF",
          colored: true,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({path:'/app'})))
        })
      ])
    ], 512),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("div", {
          class: _normalizeClass({arrow:true,arrowHidden: _ctx.arrowHidden}),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrolldown()))
        }, [
          _createVNode(_component_MovingIcon, {
            name: "down",
            autoplay: true,
            loop: true
          }),
          _hoisted_11
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Room, {
          slowRotate: true,
          properties: _ctx.roomData,
          escaped: false
        }, null, 8, ["properties"])
      ])
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", {
        class: _normalizeClass({text:true,
      Oone:_ctx.landing>0 && _ctx.landing<4,
      Otwo:_ctx.landing>3 && _ctx.landing<7,
      Othree:_ctx.landing>6 && _ctx.landing<12,
      Ofour:_ctx.landing>11,
      })
      }, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.landing=1)),
            class: _normalizeClass({line:true,marked:_ctx.landing>0 && _ctx.landing<4})
          }, _hoisted_18, 2),
          _createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.landing=4)),
            class: _normalizeClass({line:true,marked:_ctx.landing>3 && _ctx.landing<7})
          }, _hoisted_20, 2),
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.landing=7)),
            class: _normalizeClass({line:true,marked:_ctx.landing>6 && _ctx.landing<12})
          }, _hoisted_22, 2),
          _createElementVNode("div", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.landing=12)),
            class: _normalizeClass({line:true,marked:_ctx.landing>11})
          }, _hoisted_24, 2)
        ])
      ], 2),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", null, [
          _createVNode(_component_MovingIcon, {
            name: "loader_dots",
            type: "svg"
          }),
          _hoisted_26
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_MovingIcon, {
            name: "card",
            type: "svg"
          }),
          _hoisted_27
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_MovingIcon, {
            name: "tick",
            type: "svg"
          }),
          _hoisted_28
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _createVNode(_component_LandingHost, {
          stage: _ctx.landing,
          onUpdate: _cache[7] || (_cache[7] = ($event: any) => (_ctx.landing>-2?_ctx.landing=$event:false))
        }, null, 8, ["stage"])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _createElementVNode("div", {
        class: _normalizeClass({text:true,
      TWone:_ctx.invite>-1 && _ctx.invite<2,
      TWtwo:_ctx.invite>1 && _ctx.invite<5,
      TWthree:_ctx.invite>4 && _ctx.invite<11,
      TWfour:_ctx.invite>10,
      })
      }, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", {
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.invite=0)),
            class: _normalizeClass({line:true,marked:_ctx.invite>-1 && _ctx.invite<2})
          }, _hoisted_34, 2),
          _createElementVNode("div", {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.invite=2)),
            class: _normalizeClass({line:true,marked:_ctx.invite>1 && _ctx.invite<8})
          }, _hoisted_36, 2),
          _createElementVNode("div", {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.invite=8)),
            class: _normalizeClass({line:true,marked:_ctx.invite>7 && _ctx.invite<11})
          }, _hoisted_38, 2),
          _createElementVNode("div", {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.invite=11)),
            class: _normalizeClass({line:true,marked:_ctx.invite>10})
          }, _hoisted_40, 2)
        ])
      ], 2),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", null, [
          _createVNode(_component_MovingIcon, {
            name: "join",
            type: "svg"
          }),
          _hoisted_42
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_MovingIcon, {
            name: "user",
            type: "svg"
          }),
          _hoisted_43
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_MovingIcon, {
            name: "crown",
            type: "svg"
          }),
          _hoisted_44
        ])
      ]),
      _createElementVNode("div", _hoisted_45, [
        _createVNode(_component_LandingInvite, {
          stage: _ctx.invite,
          onUpdate: _cache[12] || (_cache[12] = ($event: any) => (_ctx.invite>-2?_ctx.invite=$event:false))
        }, null, 8, ["stage"])
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _hoisted_47,
      _createElementVNode("div", {
        class: _normalizeClass({text:true,
      THone:_ctx.play>-1 && _ctx.play<2,
      THtwo:_ctx.play>1 && _ctx.play<7,
      THthree:_ctx.play>6 && _ctx.play<11,
      THfour:_ctx.play>10,
      })
      }, [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", {
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.play=0)),
            class: _normalizeClass({line:true,marked:_ctx.play>-1 && _ctx.play<2})
          }, _hoisted_50, 2),
          _createElementVNode("div", {
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.play=2)),
            class: _normalizeClass({line:true,marked:_ctx.play>1 && _ctx.play<7})
          }, _hoisted_52, 2),
          _createElementVNode("div", {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.play=7)),
            class: _normalizeClass({line:true,marked:_ctx.play>6 && _ctx.play<11})
          }, _hoisted_54, 2),
          _createElementVNode("div", {
            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.play=11)),
            class: _normalizeClass({line:true,marked:_ctx.play>10})
          }, _hoisted_56, 2)
        ])
      ], 2),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", null, [
          _createVNode(_component_MovingIcon, {
            name: "door",
            type: "svg"
          }),
          _hoisted_58
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_MovingIcon, {
            name: "trend",
            type: "svg"
          }),
          _hoisted_59
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_MovingIcon, {
            name: "star",
            type: "svg"
          }),
          _hoisted_60
        ])
      ]),
      _createElementVNode("div", _hoisted_61, [
        _createVNode(_component_LandingPlay, {
          stage: _ctx.play,
          onUpdate: _cache[17] || (_cache[17] = ($event: any) => (_ctx.play>-2?_ctx.play=$event:false))
        }, null, 8, ["stage"])
      ])
    ]),
    _createElementVNode("div", _hoisted_62, [
      _hoisted_63,
      _createElementVNode("div", _hoisted_66, [
        _createVNode(_component_IconButton, {
          text: "Get started",
          colored: true,
          hex: "#ffffff",
          icon: "forward",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$router.push({path:'/app'})))
        })
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
}